<div class="stitch-cart-page py-4">
  <div class="container-fluid px-lg-5">
    
    <!-- Header & Stepper -->
    <div class="cart-stepper-header mb-4">
      <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
        <h1 class="page-title m-0"><i class="fas fa-shopping-bag me-2 text-primary"></i>Carrito de Compras</h1>
        <a routerLink="/shop" class="btn-continue-shopping text-decoration-none">
          <i class="fas fa-arrow-left me-1"></i>Seguir comprando
        </a>
      </div>

      <!-- Process Stepper -->
      <div class="stitch-checkout-stepper d-flex justify-content-center align-items-center py-3">
        <div class="step-item active">
          <span class="step-num">1</span>
          <span class="step-text">Mi Carrito</span>
        </div>
        <div class="step-line"></div>
        <div class="step-item">
          <span class="step-num">2</span>
          <span class="step-text">Envío & Datos</span>
        </div>
        <div class="step-line"></div>
        <div class="step-item">
          <span class="step-num">3</span>
          <span class="step-text">Pago & Confirmación</span>
        </div>
      </div>
    </div>

    <!-- Carrito Vacío -->
    <div *ngIf="cartItems.length === 0" class="empty-cart-card text-center py-5 shadow-sm rounded-4 bg-white">
      <div class="empty-icon-circle mb-3">
        <i class="fas fa-shopping-cart fa-3x text-muted"></i>
      </div>
      <h3 class="fw-bold">Tu carrito de compras está vacío</h3>
      <p class="text-muted mb-4">Descubre nuestros productos en oferta y agrega tus favoritos.</p>
      <a routerLink="/shop" class="btn-stitch-hero-action text-decoration-none">
        <i class="fas fa-store me-2"></i>Explorar Catálogo
      </a>
    </div>

    <!-- Carrito con Productos -->
    <div *ngIf="cartItems.length > 0" class="row g-4">
      <!-- Columna Izquierda: Lista de Ítems -->
      <div class="col-lg-8">
        <div class="stitch-items-card shadow-sm rounded-4 bg-white p-4">
          <div class="d-flex justify-content-between align-items-center pb-3 border-bottom mb-3">
            <span class="fw-bold text-dark fs-5">Productos Agregados ({{ cartItems.length }})</span>
            <button class="btn-text-danger" (click)="clearAllCart()">
              <i class="fas fa-trash-alt me-1"></i>Vaciar Carrito
            </button>
          </div>

          <div class="cart-items-list d-flex flex-column gap-3">
            <div *ngFor="let item of cartItems" class="cart-item-row d-flex flex-column flex-sm-row align-items-sm-center justify-content-between p-3 border rounded-3 gap-3">
              
              <!-- Imagen del Producto -->
              <div class="item-img-container text-center">
                <img [src]="resolveImg(item.product.imageUrl || item.product.image)" [alt]="item.product.name" (error)="onImageError($event)" />
              </div>

              <!-- Detalles del Producto -->
              <div class="item-info-container flex-grow-1">
                <span class="category-tag">{{ item.product.category || 'Destacado' }}</span>
                <h5 class="item-title mb-1">{{ item.product.name }}</h5>
                
                <div class="variant-chips d-flex flex-wrap gap-2 mt-2">
                  <span *ngIf="item.size" class="variant-chip"><i class="fas fa-ruler me-1"></i>Talla: {{ item.size }}</span>
                  <span *ngIf="item.color" class="variant-chip"><i class="fas fa-palette me-1"></i>Color: {{ item.color }}</span>
                </div>
              </div>

              <!-- Control de Cantidad (+/-) -->
              <div class="item-quantity-container d-flex align-items-center gap-2">
                <button class="btn-qty" (click)="deincreaseQuantity(item)" [disabled]="item.quantity <= 1">
                  <i class="fas fa-minus"></i>
                </button>
                <span class="qty-display">{{ item.quantity }}</span>
                <button class="btn-qty" (click)="increaseQuantity(item)">
                  <i class="fas fa-plus"></i>
                </button>
              </div>

              <!-- Precio & Eliminar -->
              <div class="item-price-container text-sm-end d-flex flex-row flex-sm-column justify-content-between align-items-center align-items-sm-end">
                <span class="price-val fs-5 fw-bold text-dark">${{ (item.product.price * item.quantity) | number }} COP</span>
                <button class="btn-remove-item mt-1" (click)="removeItem(item)" title="Eliminar ítem">
                  <i class="fas fa-times me-1"></i>Remover
                </button>
              </div>

            </div>
          </div>
        </div>

        <!-- Banner de Confianza -->
        <div class="stitch-trust-banner mt-3 p-3 rounded-4 bg-light d-flex flex-wrap justify-content-around align-items-center text-center gap-3">
          <div><i class="fas fa-truck text-primary me-2"></i><strong>Envío Seguro Colombia</strong></div>
          <div><i class="fas fa-undo text-success me-2"></i><strong>Devolución Gratis 30 días</strong></div>
          <div><i class="fas fa-lock text-info me-2"></i><strong>Pago Encriptado SSL</strong></div>
        </div>
      </div>

      <!-- Columna Derecha: Resumen de Pedido & Cupones -->
      <div class="col-lg-4">
        <div class="stitch-summary-card shadow-sm rounded-4 bg-white p-4 sticky-top" style="top: 100px;">
          <h4 class="fw-bold mb-3 border-bottom pb-2">Resumen del Pedido</h4>

          <!-- Sección de Cupones -->
          <div class="coupon-box mb-4 p-3 rounded-3 bg-light">
            <label class="fw-bold mb-2 small d-block"><i class="fas fa-ticket-alt me-1 text-primary"></i>¿Tienes un cupón de descuento?</label>
            <div class="input-group">
              <input 
                type="text" 
                class="form-control text-uppercase" 
                placeholder="Ej. DESCUENTO20" 
                [(ngModel)]="couponCode"
                (keyup.enter)="applyCoupon()"
              />
              <button class="btn btn-primary font-weight-bold" (click)="applyCoupon()">Aplicar</button>
            </div>

            <!-- Cupones Aplicados -->
            <div *ngIf="appliedDiscounts.length > 0" class="applied-coupons-list mt-3">
              <div *ngFor="let coupon of appliedDiscounts" class="d-flex justify-content-between align-items-center bg-white p-2 rounded border mb-2">
                <span class="small font-weight-bold text-success">
                  <i class="fas fa-check-circle me-1"></i>{{ coupon.code }} (-${{ coupon.discountAmount | number }})
                </span>
                <button class="btn-close-sm" (click)="removeCoupon(coupon.code)">&times;</button>
              </div>
            </div>
          </div>

          <!-- Desglose Financiero -->
          <div class="summary-totals d-flex flex-column gap-2 mb-4">
            <div class="d-flex justify-content-between text-muted">
              <span>Subtotal Productos:</span>
              <span>${{ getSubtotal() | number }} COP</span>
            </div>

            <div *ngIf="getTotalDiscount() > 0" class="d-flex justify-content-between text-success font-weight-bold">
              <span>Descuento aplicado:</span>
              <span>-${{ getTotalDiscount() | number }} COP</span>
            </div>

            <div class="d-flex justify-content-between text-muted">
              <span>Envío Estimado:</span>
              <span class="text-success font-weight-bold">Cotizado en Checkout</span>
            </div>

            <hr class="my-2" />

            <div class="d-flex justify-content-between align-items-center">
              <span class="fw-bold fs-5 text-dark">Total estimado:</span>
              <span class="fw-bold fs-4 text-primary">${{ getTotal() | number }} COP</span>
            </div>
          </div>

          <!-- Botón Principal Ir al Checkout -->
          <button class="btn-stitch-checkout w-100 py-3 rounded-3" (click)="proceedToCheckout()">
            <i class="fas fa-credit-card me-2"></i>Proceder al Pago
          </button>
        </div>
      </div>

    </div>

  </div>
</div>
